import React from 'react'
import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router'
import { Dashboard, Landing } from './screens'
import { ToastContainer } from 'react-toastify'

function App() {
	return (
		<BrowserRouter>
			<div className="App">
				<Routes>
					<Route path="/" element={<Landing />} />
					<Route path="/dashboard" element={<Dashboard />} />
				</Routes>
			</div>
			<ToastContainer />
		</BrowserRouter>
	)
}

export default App
